// @flow
'use strict';

import * as React from 'react';
import { Col, Row } from 'react-bootstrap';
import { FormSection } from 'redux-form/lib/immutable';

import SelecaoTodosCte from './selecao_todos_cte';
import { Input } from '../../../../../../common/input';

export default function CamposQtdCarga() {
  return (
    <fieldset className="grupo-download-lista">
      <legend>Quantidades de Carga</legend>
      <p className="instrucao-em-titulo">
        A lista retornará uma linha para cada quantidade de carga do CT-e.
      </p>

      <Row>
        <Col md={ 12 }>
          <FormSection name="qtdCarga">
            <SelecaoTodosCte nomes={ ['qtdCarga'] } titulo="Quantidades de Carga"/>

            <div className="grupo-checkbox">
              <Input name="qtdCargaUnMedida" label="Unidade Medida" checkbox/>
              <Input name="qtdCargaTipoMedida" label="Tipo Medida" checkbox/>
              <Input name="qtdCargaQuantidade" label="Quantidade" checkbox/>
            </div>
          </FormSection>
        </Col>
      </Row>
    </fieldset>
  );
}
